import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1927da61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "block-title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已领取的第三者责任险", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-right" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title wait-receive" }, [
  /*#__PURE__*/_createElementVNode("div", null, "待领取的第三者责任险")
], -1))
const _hoisted_8 = { class: "other-option" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "购买第三者责任险", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "免费领取第三者责任险", -1))

import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { onUnmounted, ref, Ref } from 'vue'
import { showToastLoading, clearToast } from '@/utils/tools'
import { ThreeLiabiltyListItem, WaitReceiveThreeLiabilityUavItem } from '@/types/insurance'
import { getThreeLiabilityList, getWaitReceiveThreeLiabilityUav } from '@/apis/insurance'
import Header from '@/components/Header.vue'
import CellWrap from './components/cell-wrap.vue'
import ReceiveInsuranceList from './components/receive-insurance-list.vue'
import UnReceiveInsuranceList from './components/unrecive-insurance-list.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-aggregation',
  setup(__props) {

const $router = useRouter()
const receiveList: Ref<ThreeLiabiltyListItem[]> = ref([])
const waitReceiveList: Ref<WaitReceiveThreeLiabilityUavItem[]> = ref([])
const store = useStore()

function toReceiveAll() {
  $router.push({
    name: 'three-liability-receive-insurance-all',
  })
}

function toFreeReceive() {
  $router.push({
    name: 'three-liability-free-receive',
  })
}

function toThirdPartyBuy() {
  $router.push({
    name: 'three-liability-third-party-buy',
  })
}
// 加载已领取数据
async function initReceivedData() {
  try {
    const data = await getThreeLiabilityList({
      limit: 5,
      user_guid: store?.state?.userInfo?.guid,
    })
    receiveList.value = data
  } catch (error) {
    console.log('error', error)
  }
}
// 加载待领取数据
async function initWaitReceiveData() {
  try {
    const data = await getWaitReceiveThreeLiabilityUav({
      user_guid: store?.state?.userInfo?.guid,
    })
    waitReceiveList.value = data
  } catch (error) {
    console.log('error', error)
  }
}
// 加载数据
async function initPageData() {
  showToastLoading()
  await Promise.all([initReceivedData(), initWaitReceiveData()])
  clearToast()
}

initPageData()
onUnmounted(() => {
  clearToast()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { title: "第三者责任险" }),
    _createElementVNode("div", _hoisted_1, [
      (receiveList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "more",
              onClick: toReceiveAll
            }, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      _createVNode(ReceiveInsuranceList, {
        class: "receive-content",
        list: receiveList.value,
        hideEmpty: ""
      }, null, 8, ["list"]),
      (waitReceiveList.value.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_7,
            _createVNode(UnReceiveInsuranceList, {
              class: "unreceive-content",
              list: waitReceiveList.value
            }, null, 8, ["list"])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(CellWrap, { onClick: toThirdPartyBuy }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(CellWrap, {
          class: "van-hairline--top",
          onClick: toFreeReceive
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})